import {Base} from "./Base";
import {Partner} from "./Partner";
import {Product} from "./Product";
import {Warehouse} from "./Warehouse";
import {TransactionType} from "./Transaction";

export enum ReceiveStatus {
    NotArrived = 'NOT_ARRIVE', // najavljen, nije stigao
    Arrived = 'ARRIVED', // stigao
    Finished = 'FINISHED', // zavrsen istovar, zakljucena prijemnica
}

export interface DocumentOfReceive extends Base {
    id: string
    documentId?: string
    finishedDocumentId?: string
    finishedDocumentNumber?: string; // format "redni/godina" za prikaz, npr "15/2025"
    status?: ReceiveStatus
    warehouse: Warehouse
    warehouseName?: string //from requests/dispositions
    warehouseman?: string
    type?: TransactionType
    brutto?: number
    tara?: number
    netto?: number
    srps?: number
    date?: Date
    time?: Date
    product?: Product
    repromaterialProducts?: Product[]
    repromaterialProductsJSON?: string
    productWithCode?: string
    partner?: Partner
    shipper?: Partner
    driverName?: string
    vehicleNumber?: string
    moisture?: number
    impurity?: number
    breakage?: number
    defect?: number
    hectoliter?: number
    protein?: number
    gluten?: number
    cellNumberFloor?: string
    hybrid?: string
    dryingCosts?: number
    dryWeight?: number
    shippingSlip?: string
    sentQuantity?: number
    calculationMethod?: boolean // true - metod svodjenja na srps, false - metod obracuna 1:1 (neto)
    foreignProduct?: boolean // true - tudja roba na skladistenju
    productOwner?: Partner
    note?: string
    dispositionId?: string //na osnovu koje id dispozicije je kreirana prijemnica/otpremnica
    finishedDocument?: boolean // true - zakljucena prijemnica/otpremnnica, moze se otkljucavati/zakljucavati
    finishedDocumentFirstTime?: boolean // postavlja se na true kad se zakljuci prijemnica/otpremnica prvi put; potreban je zbog stvarnog datuma prijema/otpreme
                                        // koristi se kod prijemnice/otpremnice koja se formira na osnovu dispizicije.
                                        // dok se ne zakljuci prijemnica/otpremnica prvi put, datum je u trenutku zakljucenja, 
                                        // kad se zakljuci prvi put, datum je u trenutku prvog zakljucenja prijemnice/otpremnice 
    loadingCityName?: string //mesto utovara (za prijemnicu) / istovara (za otpremnicu)
    loadingContact?: string; //kontakt na istovaru
    shipperInvoiceId?: string //broj fakture troskova transporta
    controlHouseInvoiceId?: string //broj fakture troskova kontrolnih kuca
    documentPairId?: string //za dokumente generisane na osnovu dispozicije tipa premestaj,
                            //predstavlja broj drugog dokumenta koji je istovremeno generisan
    mercantile?: boolean //true - merkantila, false - repromaterijal
    input?: boolean //true - prijem, false - otprema robe
    isNatural?: boolean; //da li je naturalna/merkantilna roba
}


export interface DocumentShort extends Base {
    id: string
    finishedDocument: boolean
    finishedDocumentId: string
    finishedDocumentNumber?: string;
    documentPairId: string
    status: string
    date: Date
    time?: Date
    loadingCityName?: string
    categoryId?: string
    categoryName?: string
    productId?: string
    productName?: string
    warehouseId: string
    warehouseName: string
    cellNumberFloor?: string
    partnerId?: string
    partnerName?: string
    driverName?: string
    vehicleNumber: string
    moisture?: number
    impurity?: number
    breakage?: number
    defect?: number
    hectoliter?: number
    protein?: number
    brutto?: number
    tara?: number
    netto?: number
    calculationMethod?: boolean
    srps?: number
    dryingCosts?: number
    dryWeight?: number
    sentQuantity?: number
    shipperInvoiceId?: string
    controlHouseInvoiceId?: string
    isDocumentFinished?: boolean
    shipperName?: string
    reproProducts?: string
    reproProductIds?: string
    reproAmounts?: string
    mercantile?: boolean
    input?: boolean
    dispositionId?: string
    note?: string
    isNatural?: boolean;
}

export interface ProductInputDoradaListItem {
    id: string;
    documentId: number;
    finishedDocumentId?: number;

    dcContext?: 'DORADA';
    isNatural?: boolean;

    input: boolean; // true prijemnica / false otpremnica
    mercantile: boolean;
    status?: string;

    date?: Date;
    time?: Date;

    productId?: string;
    productName?: string;

    warehouseId?: string;
    warehouseName?: string;

    partnerId?: string;
    partnerName?: string;

    brutto?: number;
    tara?: number;
    netto?: number;

    doradaRequestId?: string;
    doradaDispositionId?: string;
}